import { SupportMessage } from '@/hooks/useSupportChat';
import { cn } from '@/lib/utils';

interface Props {
  message: SupportMessage;
  isOwn: boolean;
}

export const MessageBubble = ({ message, isOwn }: Props) => {
  const isBot = message.sender_type === 'bot';
  const isAdmin = message.sender_type === 'admin';

  const label = isBot ? 'Bot Velox' : isAdmin ? 'Support Velox' : '';

  return (
    <div className={cn('flex w-full mb-3', isOwn ? 'justify-end' : 'justify-start')}>
      <div className="max-w-[80%]">
        {!isOwn && label && (
          <p className="text-xs text-[#5A6B7A] mb-1 px-1 font-medium">{label}</p>
        )}
        <div
          className={cn(
            'rounded-2xl px-4 py-2 text-sm',
            isOwn
              ? 'bg-[#37699E] text-white rounded-br-sm'
              : isBot
              ? 'bg-[#254566] text-white border border-[#37699E] rounded-bl-sm'
              : 'bg-[#EBF4F8] text-[#2D3748] rounded-bl-sm'
          )}
        >
          <p className="whitespace-pre-wrap break-words">{message.content}</p>
        </div>
        <p className={cn('text-[10px] text-[#87ADD4] mt-1 px-1', isOwn ? 'text-right' : 'text-left')}>
          {new Date(message.created_at).toLocaleString('fr-FR', {
            day: '2-digit',
            month: '2-digit',
            hour: '2-digit',
            minute: '2-digit',
          })}
        </p>
      </div>
    </div>
  );
};
